// AI usage summary (the legacy /agents/admin/usage-summary rollup).
// Moved verbatim out of aiUsageApi.ts.

import { adminGet } from './transport';

export interface AiUsageOperationRow {
  operation: string;
  requests: number;
  costUsd: number;
  credits: number;
}

export interface AiUsageTenantRow {
  tenantId: string;
  /** Business name (best-effort); undefined → fall back to tenantId. */
  tenantName?: string;
  /** Current outstanding credit balance (live, not range-scoped). */
  balance?: number;
  requests: number;
  tokens: number;
  costUsd: number;
  credits?: number;
  avgLatencyMs: number;
  classification: Record<string, number>;
  /** Per-category drill-down of this tenant's spend (newer backends only). */
  operations?: AiUsageOperationRow[];
}

export interface AiUsageAlert {
  pk: string;
  sk: string;
  severity: string;
  type?: string;
  message?: string;
  checkedAt?: string;
}

export interface AiUsageSummary {
  sinceIso: string;
  untilIso?: string;
  totals: {
    requests: number;
    tokens: number;
    costUsd: number;
    activeTenants: number;
  };
  tenants: AiUsageTenantRow[];
  alerts: AiUsageAlert[];
}

export async function getAiUsageSummary(
  range: { hours?: number; fromIso?: string; toIso?: string } = {},
): Promise<AiUsageSummary> {
  const p = new URLSearchParams();
  if (range.fromIso) p.set('from', range.fromIso);
  if (range.toIso) p.set('to', range.toIso);
  if (!range.fromIso && !range.toIso) p.set('hours', String(range.hours ?? 24));
  return adminGet<AiUsageSummary>(`/agents/admin/usage-summary?${p.toString()}`);
}
